import type { ChangeEvent, RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../../pages/TreatmentPlanBuilderPage.module.css';

const TITLE_MAX_LENGTH = 80;

interface TemplateTitleFieldProps {
  name: string;
  strokeColor: string;
  error?: string;
  isDirty: boolean;
  inputRef: RefObject<HTMLInputElement | null>;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const TemplateTitleField = ({
  name,
  strokeColor,
  error,
  isDirty,
  inputRef,
  onChange
}: TemplateTitleFieldProps) => {
  const { t } = useTranslation();

  const borderColor = error
    ? 'var(--color-error-primary)'
    : strokeColor || 'var(--color-border-primary)';

  return (
    <div className={styles.titleLeft}>
      <div className={styles.titleField}>
        <input
          ref={inputRef}
          className={styles.titleInput}
          value={name}
          onChange={onChange}
          placeholder={t('config-builder-title-placeholder')}
          maxLength={TITLE_MAX_LENGTH}
          aria-invalid={Boolean(error)}
          style={{ borderBottom: `2px solid ${borderColor}` }}
        />
        {error && <span className={styles.fieldError}>{error}</span>}
      </div>
      {isDirty && <span className={styles.dirtyIndicator}>{t('config-builder-unsaved')}</span>}
    </div>
  );
};
